import { PREPROCESSING_FUND_PROFILES_FUNDS_GET } from '../actions/types';

const initialState = {
  clusteredFunds: [],
  interval: null,
  numberOfClusters: null,
  peerProfileId: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case PREPROCESSING_FUND_PROFILES_FUNDS_GET._SUCCESS: {
      const {
        clusteredFunds,
        clusteredFundsMap,
        interval,
        numberOfClusters,
        peerProfileId,
      } = action.payload;

      // store this for refresh
      state.interval = interval;
      state.numberOfClusters = numberOfClusters;
      state.peerProfileId = peerProfileId;

      state.clusteredFunds = clusteredFunds;
      state.clusteredFundsMap = clusteredFundsMap;
      return state;
    }
    default:
      return state;
  }
};

export { reducer as preprocessingFundProfiles };
